import type { Marking } from './schema'
import { hasMarkElementIn, wrapRangeWithMark } from './dom'
import { locateMarkingRange } from './locate'
import { collectMarkableText } from './text-filter'
import { markingRoots } from './source'
import { isMarkingColor } from './schema'

export function placeMarkingInContainer(container: Element, marking: Marking) {
  if (!isMarkingColor(marking.color)) {
    return { placed: false, failed: false, renderFailed: false }
  }

  const selections = marking.segments
    ?? [{ ...marking, unitId: marking.source.unitId, documentId: marking.source.documentId }]
  let placed = 0
  let failed = false
  let renderFailed = false

  for (const selection of selections) {
    const roots = markingRoots(container, {
      source: {
        ...marking.source,
        unitId: selection.unitId,
        documentId: selection.documentId ?? marking.source.documentId,
      },
    })

    for (const root of roots) {
      if (hasMarkElementIn(root, marking.id)) {
        placed++
        break
      }

      const text = collectMarkableText(root)

      if (!text) {
        continue
      }

      const range = locateMarkingRange(root, selection, text)

      if (!range) {
        failed = true
        continue
      }

      try {
        wrapRangeWithMark(range, { id: marking.id, color: marking.color })
        placed++
      }
      catch {
        renderFailed = true
      }

      break
    }
  }

  return { placed: placed === selections.length, failed, renderFailed }
}
